import { useEffect } from "react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { AlertCircle, Home, RefreshCw } from "lucide-react";

export default function Error500() {
  useEffect(() => {
    // Log error to analytics if available
    console.error("500 Error page loaded");
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-teal-50 to-amber-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full bg-white/90 backdrop-blur shadow-xl border-purple-200 p-8">
        <div className="text-center space-y-6">
          <div className="mx-auto w-20 h-20 bg-gradient-to-br from-purple-600 to-teal-600 rounded-full flex items-center justify-center">
            <AlertCircle className="w-12 h-12 text-white" />
          </div>
          
          <div className="space-y-2">
            <h1 className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-teal-600 bg-clip-text text-transparent">
              Oops! Something went wrong
            </h1>
            <p className="text-gray-600">
              We're having trouble loading this page. Our magical story elves are working on fixing it!
            </p>
          </div>

          <div className="bg-purple-50 rounded-lg p-4">
            <p className="text-sm text-purple-700">
              <strong>Error 500:</strong> Internal Server Error
            </p>
          </div>

          <div className="space-y-3">
            <Button
              onClick={handleRefresh}
              className="w-full bg-gradient-to-r from-purple-600 to-teal-600 hover:from-purple-700 hover:to-teal-700"
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              Try Again
            </Button>
            
            <Link href="/home">
              <Button variant="gradient" className="w-full text-white">
                <Home className="mr-2 h-4 w-4" />
                Go Home
              </Button>
            </Link>
          </div>

          <p className="text-xs text-gray-500">
            If this problem persists, please contact support@SnuggleCrafters.com
          </p>
        </div>
      </Card>
    </div>
  );
}